import React from "react";
import { InputJson, Button } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import {
  getObjectUseCase,
  upsertUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import FormPayrollPresenter from "./FormPayrollPresenter";
import TablePayroll from "../table-payroll/TablePayroll";
import { getHeader } from "../table-payroll/header/TableHeader";
import { getHeaderSP } from "../table-payroll/header/TableHeaderSP";
import { getHeaderIP } from "../table-payroll/header/TableHeaderIP";
import LogoHeader from "../../../../components/common/LogoHeader";
import { calculations } from "../calculation-payroll/CalculationPayroll";
import { caseKeyMap } from "../payroll-cases/CaseKeyMap";
import { getmodifiedTable } from "./table-object-helper/ModifyTable";
import {
  updateTableObjects,
  updateTableObjects_1,
  updateTableObjects_2,
  updateTableObjects_3,
} from "./table-object-helper/TransformTableObjects";
import {
  convertLabels,
  mergeHeaders,
  getWholeDaysofMonth,
  countDateRanges,
  getDatesFromRange,
  sumProperties,
  getMonthNames,
  countAirportDuties,
  toCamelCase,
} from "../helper-payroll/HelperFunction";
import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../helper-payroll/constants/payrollConstants";
import PayrollHeaderDisplay from "../../../../components/PayrollHeader/PayrollHeaderDisplay";
import PayrollFooterDisplay from "../../../../components/PayrollFooter/PayrollFooterDisplay";
import ProgressDialog from "../../../../components/common/ProgressDialog";
import { processAttendanceStats } from "../attendance-helper/ProcessAttendanceHelper";

export default class FormPayrollPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      isLoading: true,
      tableHeaders: {},
      tableObjects: [],
      tfootObjects: {},
      requestLists: {},
      deductionLists: {},
      otherCalculations: {},
      dateMetrics: {},
      value: 2000,
      dateRange: [],
      employees: [],
      isDataAddinRow: 1,
      isRemoved: false,
      signatories: {
        sectionName_1: "RHUBIE M. TAMAYO",
        sectionPos_1: "Acting Chief, Compensation & Employee Benefits Section",
        sectionName_2: "CHESTER KEVIN S. SY",
        sectionPos_2: "Chief, Accounting Section",
        sectionName_3: "MARY ANN Q. CARANTO",
        sectionPos_3: "Chief Administrative Division",
        sectionName_4: "LILIBETH F. LINTAG",
        sectionPos_4: "Disbursing Officer",
      },
      showProgressModal: false,
      saveProgress: 0,
      savedCount: 0,
      totalCount: 0,
      loadProgress: 0,
      loadedCount: 0,
      loadTotalCount: 0,
      salaryGrade: {},
      processedAttendance: {},
    };
    this.contractPDF = React.createRef();
    // this.printRef = React.createRef();
    this.presenter = new FormPayrollPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase()
    );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  
    const { selectedTypes, objects, otherInfo, datePicked } =
      this.props;
  
    const { payrollTypes, jobTypeID } = selectedTypes;
  
    const airportSched =
      otherInfo?.numberOfDutiesinAP?.filteredEmployeeDuty;
      
    const totalLoadWeight = 10;
  
    let completedLoadWeight = 0;
  
    const nextFrame = () =>
      new Promise((resolve) =>
        requestAnimationFrame(resolve)
      );
  
    const sleep = (ms) =>
      new Promise((resolve) => setTimeout(resolve, ms));
  
    const bumpLoadProgress = async (weight = 1) => {
      completedLoadWeight = Math.min(
        completedLoadWeight + weight,
        totalLoadWeight
      );
  
      const progress = Math.round(
        (completedLoadWeight / totalLoadWeight) * 95
      );
  
      this.setState({
        loadProgress: progress,
        loadedCount: progress,
        loadTotalCount: 100,
      });
  
      // allow browser repaint
      await nextFrame();
    };
  
    this.setState({
      isLoading: true,
      loadProgress: 0,
      loadedCount: 0,
      loadTotalCount: 100,
    });
  
    console.log("airportSched", airportSched);
    console.log("objects", objects);
  
    const [otherDeduction, contributions, incentives] =
      await Promise.all([
        findObjectUseCase().execute("other_deductions", {
          include: [
            "accTitleRelation.accountsTitle",
            "employmentTypes",
          ],
          where: {
            payrollTypes: selectedTypes?.payrollTypeVal,
            "employmentTypes.id": jobTypeID,
            payItems: selectedTypes?.payItemVal,
          },
        }),
  
        findObjectUseCase().execute("contribution_type"),
  
        findObjectUseCase().execute("incentive", {
          include: ["allowanceType"],
          where: {
            id: otherInfo.incentiveId,
          },
        }),
      ]);
  
    await bumpLoadProgress();
    await nextFrame();
  
    const salaryGrade =
      await this.presenter.fetchSalaryGrade(
        datePicked,
        objects
      );
  
    console.log("salaryGrade", salaryGrade);
  
    await bumpLoadProgress();
  
    const contributionType = contributions.map(
      (item) => item.contributionType
    );
  
    const { DEDUCTION, ADDITIONAL } =
      otherDeduction.reduce(
        (acc, item) => {
          const isDeduction =
            item?.deductionTypes ===
            "Other Deduction";
  
          const isAdditional =
            item?.deductionTypes ===
            "Other Additional";
  
          if (
            !item?.accTitleRelation ||
            (!isDeduction && !isAdditional)
          ) {
            return acc;
          }
  
          for (const rel of item?.accTitleRelation) {
            const name =
              rel?.accountsTitle?.name;
  
            if (!name) continue;
  
            if (isDeduction) {
              acc.DEDUCTION.push(name);
            } else if (isAdditional) {
              acc.ADDITIONAL.push(name);
            }
          }
  
          return acc;
        },
        {
          DEDUCTION: [],
          ADDITIONAL: [],
        }
      );
  
    const deductionLists = {
      deductionType: DEDUCTION,
      additionalType: ADDITIONAL,
      contributionType,
      contributions,
      incentives,
      otherInfo,
    };

    const [
      tableHeader,
      primarySubHdr,
      secondarySubHdr,
    ] =
      payrollTypes === "SP"
        ? getHeaderSP(
            selectedTypes,
            deductionLists
          )
        : payrollTypes === "IP"
        ? getHeaderIP(
            selectedTypes,
            deductionLists
          )
        : getHeader(
            selectedTypes,
            deductionLists
          );
  
    await nextFrame();
  
    const requestLists =
      await this.presenter.getRequests(
        deductionLists,
        salaryGrade
      );
  
    console.log("requestLists", requestLists);
  
    await bumpLoadProgress();

    await nextFrame();
  
    const processedAttendance =
      await processAttendanceStats(
        objects,
        datePicked,
        otherInfo?.caseName,
        airportSched
      );
  
    console.log(
      "processedAttendance",
      processedAttendance
    );
  
    // processAttendanceStats is the heaviest step — count it as 3 units
    await bumpLoadProgress(3);
    await nextFrame();
  
    const otherCalculations = calculations(
      objects,
      selectedTypes,
      requestLists,
      otherInfo,
      datePicked,
      "",
      {},
      salaryGrade,
      processedAttendance
    );
  
    await bumpLoadProgress();
    await nextFrame();
  
    const tableObjects =
      this.presenter._getTableData(
        objects,
        otherCalculations,
        requestLists,
        salaryGrade
      );
  
    console.log("tableObjects", tableObjects);
  
    await bumpLoadProgress();

    const caseName =
      this.presenter.getMatchingCase();
  
    const keysToSum =
      caseKeyMap[caseName] || [];
  
    await nextFrame();
  
    const tfootObjects = sumProperties(
      tableObjects,
      keysToSum,
      deductionLists
    );
  
    console.log(
      "tfootObjects",
      tfootObjects
    );
  
    await bumpLoadProgress();

    await nextFrame();
  
    const combinedHeaders =
      mergeHeaders(
        tableHeader,
        primarySubHdr,
        secondarySubHdr
      );
  
    const convertedHeaders =
      convertLabels(combinedHeaders);
  
    console.log(
      "convertedHeaders",
      convertedHeaders
    );
  
    const tableHeaders = {
      tableHeader,
      primarySubHdr,
      secondarySubHdr,
      convertedHeaders,
    };
  
    await bumpLoadProgress();
  
    this.setState({
      loadProgress: 100,
      loadedCount: 100,
      loadTotalCount: 100,
    });
  
    // Hold on 100% briefly so the user actually sees it reach the end
    // before the dialog closes.
    await nextFrame();
    await sleep(400);
  
    this.setState({
      tableHeaders,
      requestLists,
      deductionLists,
      tableObjects,
      tfootObjects,
      otherCalculations,
      salaryGrade,
      processedAttendance,
      isLoading: false,
    });
  }


  async componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      this.handleInputFieldChange();
    }
    if (prevState.dateRange !== this.state.dateRange) {
      console.log("dateRange changed");
      await this.handleDateRangeChange();
    }
  }

  async handleInputFieldChange() {
    console.log("handleInputFieldChange");
    const { selectedTypes, objects, otherInfo, datePicked } = this.props;
    const { tableObjects, deductionLists, requestLists, value, salaryGrade, processedAttendance } = this.state;

    const otherCalculations = calculations(
      objects,
      selectedTypes,
      requestLists,
      otherInfo,
      datePicked,
      value,
      tableObjects,
      salaryGrade,
      processedAttendance
    );

    const caseListName = this.presenter.getCaseListName();
    const { caseLists, cases } = caseListName;
    const params = {
      otherCalculations,
      tableObjects,
      caseLists,
      cases,
      selectedTypes,
    };
    const newTableObject = updateTableObjects(params);

    console.log("newTableObject", newTableObject);

    const caseName = this.presenter.getMatchingCase();
    const keysToSum = caseKeyMap[caseName] || [];

    const tfootObjects = sumProperties(
      newTableObject,
      keysToSum,
      deductionLists
    );

    console.log("tfootObjectsss+++", tfootObjects);

    this.setState({ tableObjects: newTableObject, tfootObjects });
  }

  async handleDateRangeChange() {
    const {
      tableObjects,
      employees,
      dateMetrics,
      isRemoved,
      isDataAddinRow,
      deductionLists,
      requestLists,
    } = this.state;
    
    const { selectedTypes, objects, otherInfo, datePicked } = this.props;
    const { daysInMonth, periodCount, selectedDate, monthNames } = dateMetrics;
    const airportSched = otherInfo?.numberOfDutiesinAP?.filteredEmployeeDuty;
    
    const salaryGrade = await this.presenter.fetchSalaryGrade(selectedDate, objects, true)
    const caseListName = this.presenter.getCaseListName();
    const { caseLists, cases } = caseListName;
    let caseName = cases;
    if(cases === "isThirdCase") {
      caseName = "BASIC_BACKPAY";
    } else if(cases === "isSixthCase") {
      caseName = "BASIC_JO_ADDENDUM";
    } else if(cases === "isEightCase") {
      caseName = "INDIVIDUAL_INITIAL_LAST_AP";
    } else if(cases === "isEleventhCase") {
      caseName = "INDIVIDUAL_JO_INITIAL_LAST";
    } else if(cases === "isTwelvethCase") {
      caseName = "AP_BACKPAY";
    }
    const mandatoryFormula = requestLists?.mandatoryFormula || {};

    console.log("mandatoryFormula", mandatoryFormula);

    const processedAttendance = await processAttendanceStats(objects, selectedDate, otherInfo?.caseName, airportSched);
    console.log("processedAttendance", processedAttendance);
    const noOfDuties = countAirportDuties(airportSched, selectedDate, objects);


    const params_1 = {
      tableObjects,
      noOfDuties,
      daysInMonth,
      periodCount,
      monthNames,
      cases,
      employees,
      processedAttendance,
    };
    const updatedTableObj = updateTableObjects_1(params_1);

    // console.log("updatedTableObj", updatedTableObj);

    this.setState({ tableObjects: updatedTableObj }, async () => {
      const otherCalculations = calculations(
        objects,
        selectedTypes,
        requestLists,
        otherInfo,
        datePicked,
        this.state.value,
        updatedTableObj,
        salaryGrade,
        {}
      );

      const params_2 = {
        otherCalculations,
        updatedTableObj,
        caseLists,
        cases,
      };
      const newTableObject = updateTableObjects_2(params_2);

      console.log("newTableObject", newTableObject);

      const caseName = this.presenter.getMatchingCase();
      const keysToSum = caseKeyMap[caseName] || [];


      if (isDataAddinRow >= 1) {
        const args = {
          newTableObject,
          isMultipleRows: isDataAddinRow > 1,
          isRemoved,
          mandatoryFormula,
          caseName,
          value: this.state.value,
        };

        const modifiedTable = getmodifiedTable(args);

        // console.log("modifiedTable", modifiedTable);

        const otherCalculations = calculations(
          objects,
          selectedTypes,
          requestLists,
          otherInfo,
          datePicked,
          this.state.value,
          modifiedTable,
         salaryGrade,
         {}
        );

        const params_3 = {
          otherCalculations,
          modifiedTable,
          caseLists,
          cases,
        };

        const modifiedTableObject = updateTableObjects_3(params_3);

        // console.log("modifiedTableObject", modifiedTableObject);

        const tfootObjects = sumProperties(
          modifiedTableObject,
          keysToSum,
          deductionLists
        );

        this.setState({ tableObjects: modifiedTableObject, tfootObjects });
      } else {
        const tfootObjects = sumProperties(
          newTableObject,
          keysToSum,
          deductionLists
        );
        this.setState({ tableObjects: newTableObject, tfootObjects });
      }
    });
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  getCollectionName() {
    return "payroll";
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleSignatoryChange = (section, value) => {
    this.setState((prevState) => ({
      signatories: {
        ...prevState.signatories,
        [section]: value,
      },
    }));
  };

  handleAction(type, index, label) {
    if (type === "Add") {
      this.setState((prevState) => ({
        isDataAddinRow: (prevState.isDataAddinRow || 0) + 1,
        isRemoved: false,
      }));
    } else {
      this.setState({ isRemoved: true });
    }
  }

  handleInputChange(value, index, label, id) {
    const updatedValue = { ...this.state.value };
    const { selectedTypes } = this.props;

    if (!updatedValue[index]) updatedValue[index] = {};

    if (label !== "date") {
      updatedValue[index][label] = value === "" ? "" : value;

      this.setState({ value: updatedValue });
      return;
    }

    // Handle date input
    if (Array.isArray(value)) {
      const flattenedValue = value.flat() ?? [];
      const combinedDates = flattenedValue
        .map((datePair) => {
          if (Array.isArray(datePair) && datePair.length === 2) {
            return `${datePair[0]} - ${datePair[1]}`;
          }
          return null;
        })
        .filter(Boolean);

      // If clearing the date (empty array), clear the dateRange and recalculate metrics
      // This will trigger handleDateRangeChange to sync array lengths
      if (combinedDates.length === 0) {
        const dateRange = [...this.state.dateRange];
        dateRange[id] = [];
        const employees = this.props.objects.filter((item) => item.id === id);

        const selectedDate = getDatesFromRange(dateRange);
        const daysInMonth = getWholeDaysofMonth(dateRange);
        const periodCount = countDateRanges(dateRange);
        const monthNames = getMonthNames(dateRange);

        const dateMetrics = {
          selectedDate,
          daysInMonth,
          periodCount,
          monthNames,
        };

        this.setState({ value: updatedValue, dateRange, employees, dateMetrics });
        return;
      }

      const dateRange = [...this.state.dateRange];
      // Replace the date range instead of appending to prevent duplicates
      // The date picker sends the complete array of all date ranges, so we replace it
      dateRange[id] = combinedDates;
      const employees = this.props.objects.filter((item) => item.id === id);

      const selectedDate = getDatesFromRange(dateRange);
      const daysInMonth = getWholeDaysofMonth(dateRange);
      const periodCount = countDateRanges(dateRange);
      const monthNames = getMonthNames(dateRange);

      const dateMetrics = {
        selectedDate,
        daysInMonth,
        periodCount,
        monthNames,
      };


      console.log("dateRange", dateRange);

      this.setState({ value: updatedValue, dateRange, employees, dateMetrics });
    } else if (value === null || value === undefined) {
      // Handle null/undefined when date is cleared via clear button
      // Recalculate metrics to trigger handleDateRangeChange for array syncing
      const dateRange = [...this.state.dateRange];
      dateRange[id] = [];
      const employees = this.props.objects.filter((item) => item.id === id);

      const selectedDate = getDatesFromRange(dateRange);
      const daysInMonth = getWholeDaysofMonth(dateRange);
      const periodCount = countDateRanges(dateRange);
      const monthNames = getMonthNames(dateRange);

      const dateMetrics = {
        selectedDate,
        daysInMonth,
        periodCount,
        monthNames,
      };

      this.setState({ value: updatedValue, dateRange, employees, dateMetrics });
    }
  }

  render() {
    const { tableHeaders, tableObjects, tfootObjects, signatories, dateRange } =
      this.state;
    console.log("tableObjectss", tableObjects);
    const { closeFloating, datePicked, selectedTypes, otherInfo } = this.props;
    const { periodCovered, selectedYear, monthFrom, monthTo, payrollHeader, twentyPercentYear } =
      otherInfo;

    const schema = this.getSchema(this.getCollectionName());

    if (!schema) return <h1>no schema</h1>;

    const buttons = [
      {
        label: "Save",
        icon: "bi-save",
        type: "submit",
        className: "btn btn-primary",
      },
      {
        label: "Cancel",
        icon: "bi-x-circle",
        type: "button",
        className: "btn btn-light",
        onClick: closeFloating,
      },
      {
        label: "Print",
        icon: "bi-printer",
        type: "button",
        className: "btn border-primary text-primary",
        onClick: () => this.presenter._onPrintPayroll(),
      },
    ];
    return (
      <>
        <FloatingForm width="95%">
          <CardView style={{ padding: 0 }}>
            <h4 className="p-2 m-0 text-primary">Generate Payroll</h4>
            <hr className="m-0 mb-2"></hr>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.presenter._onSavePayroll();
              }}
            >
              {/* <div className="d-flex justify-content-center flex-column align-items-center flex-md-row  p-2">
                <LogoHeader
                  logoSrc={"/BIR.png"}
                  rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
                  mainLabel="Republic Of the Philippines"
                  subLabel="BUREAU OF IMMIGRATION"
                  description="Patriotism * Integrity * Professionalism"
                />
              </div> */}
              {payrollHeader?.value?.header && (
                <div className="mb-1">
                  <PayrollHeaderDisplay header={payrollHeader?.value?.header} />
                </div>
              )}
              <h5 className="text-center">{selectedTypes?.payrollTypeVal}</h5>
              <p className="text-center">{otherInfo?.payrollCode}</p>
              {!(
                isAddendumBackPayItem(selectedTypes?.payItems) ||
                isBackPayItem(selectedTypes?.payItems)
              ) && (
                <p className="text-center">
                  {periodCovered?.startDate && periodCovered?.endDate
                    ? `${periodCovered.startDate} - ${periodCovered.endDate}`
                    : selectedYear
                    ? selectedYear
                    : `${monthFrom}${monthTo ? ` - ${monthTo}` : ""}${twentyPercentYear ? ` ${twentyPercentYear}` : ""}`}
                </p>
              )}

              <div className="row pt-2 ps-2 pe-2 pb-0 m-0">
                <div className="pt-1 ps-1 pe-1 pb-0 ">
                  <TablePayroll
                    tableHeader={tableHeaders?.tableHeader ?? []}
                    primarySubHdr={tableHeaders?.primarySubHdr ?? []}
                    secondarySubHdr={tableHeaders?.secondarySubHdr ?? []}
                    headersKey={tableHeaders?.convertedHeaders}
                    object={this.state.tableObjects}
                    tfootObjects={tfootObjects}
                    selectedTypes={selectedTypes}
                    isLoading={this.state.isLoading}
                    loadingProgress={this.state.loadProgress}
                    processedCount={this.state.loadedCount}
                    totalCount={this.state.loadTotalCount}
                    onChange={this.handleInputChange.bind(this)}
                    onclickAction={this.handleAction.bind(this)}
                    value={this.state.value}
                    schema={schema}
                  />
                </div>
              </div>
              <br></br>

              {/* <div style={{ display: "none" }}>
                <div ref={this.contractPDF} id="contractPDF">
                  <PrintPayrollList
                    object={tableObjects}
                    headers={tableHeaders}
                    tfootObjects={tfootObjects}
                    otherData={{
                      selectedTypes,
                      value: this.state.value,
                      signatories,
                    }}
                  />
                </div>
              </div> */}

              {/* <FormFooter
                signatories={signatories}
                onNameChange={this.handleSignatoryChange}
                onPositionChange={this.handleSignatoryChange}
              /> */}
              
              <PayrollFooterDisplay footer={payrollHeader?.value?.footer} />

              <hr></hr>
              {/* Sticky buttons at bottom */}
              <div 
                className="w-100 d-flex justify-content-end gap-2"
                style={{
                  position: 'sticky',
                  bottom: 0,
                  backgroundColor: 'white',
                  padding: '1rem 1.5rem',
                  zIndex: 1000,
                  marginTop: '1rem',
                }}
              >
                {buttons.map(({ label, icon, type, className, onClick }) => (
                  <Button
                    type={type}
                    key={label}
                    className={className}
                    onClick={onClick}
                  >
                    <i className={`bi ${icon}`}></i>&nbsp;{label}
                  </Button>
                ))}
              </div>
            </form>
          </CardView>
        </FloatingForm>

         {this.state.showProgressModal && (
          <ProgressDialog
            saveProgress={this.state.saveProgress}
            savedCount={this.state.savedCount}
            totalCount={this.state.totalCount}
          />
        )}
      </>
    );
  }
}
